import React from "react";

class MapContainer extends React.Component {
  render() {
    return (
      <div className="card mb-4">
        <div className="card-body">
          <div className="card-header">
            <h5 className="card-title">Map</h5>
          </div>
          <div className="map-content">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2035.4229812090996!2d18.081986816154455!3d59.32589171834026!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x465f9d5641a77669%3A0xe02744b36aab9f53!2sExercisplan%204%2C%20111%2049%20Stockholm%2C%20Sweden!5e0!3m2!1sen!2sbd!4v1653796283470!5m2!1sen!2sbd"
              width="100%"
              height="500"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="This is a Google Map"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default MapContainer;
